export const validateFormspreeEndpoint = (value) => {
  if (typeof value !== 'string' || !value.trim()) {
    return { endpoint: null, reason: 'missing' };
  }

  try {
    const url = new URL(value.trim());
    const valid = url.protocol === 'https:' &&
      url.hostname === 'formspree.io' &&
      !url.port && !url.username && !url.password && !url.search && !url.hash &&
      /^\/f\/[A-Za-z0-9_-]+\/?$/.test(url.pathname);

    return valid
      ? { endpoint: url.toString(), reason: null }
      : { endpoint: null, reason: 'malformed' };
  } catch {
    return { endpoint: null, reason: 'malformed' };
  }
};

// An unavailable optional form must never prevent the static site from mounting.
export const formspreeConfig = validateFormspreeEndpoint(
  process.env.REACT_APP_FORMSPREE_ENDPOINT
);